const medicineProductSl = {
  breadcrumbs: { home: 'මුල් පිටුව', medicineBazar: 'ඖෂධ බසාර්' },
  loading: 'පූරණය වෙමින්...',
  labels: {
    prescriptionRequired: 'වෙද පොත අවශ්‍යයි',
    reviewsSuffix: 'සමාලෝචන',
    deliveryPrefix: 'බෙදාහැරීම:',
    minOrderPrefix: 'අවම ඇණවුම:',
    perUnitPrefix: 'එකක',
    expiry: 'කල් ඉකුත් වීම:',
    stock: 'තාක්‌ශණය:',
    inStock: 'තොග ඇත',
    outOfStock: 'තොග නැත',
    availableUnitsSuffix: 'පවතියි',
    selectQuantity: 'ප්‍රමාණය තෝරන්න:',
    unitLabel: ' ඒකකය',
    unitStrip: 'ස්ට්‍රිප්',
    unitBox: 'පැකේට්',
    unitTablet: 'ටැබ්ලට්',
    unitBottle: 'බෝතල',
    unitVial: 'වයල්',
    unitAmpule: 'ඇම්පියුල',
    unitTube: 'ටියුබ්',
    unitSachet: 'සැෂේ',
    unitInhaler: 'ඉන්හේලර්',
    perUnitNotePrefix: '* එක්',
    totalAmountPrefix: 'මුළු:',
    addToCart: 'කර්ට් එකට',
    wishlistAria: 'අකැමති ලැයිස්තුවට එක් කරන්න',
    shareAria: 'හවුල් වෙන්න',
    descriptionTab: 'විස්තර',
    specsTab: 'විශේෂාංග',
    reviewsTab: 'විචාර',
    productDescriptionTitle: 'ඖෂධ විස්තරය',
    productSpecsTitle: 'ඖෂධ විශේෂාංග',
    customerReviewsTitle: 'පාරිභෝගික විචාර',
    relatedTitle: 'අදාළ ඖෂධ'
  },
  messages: { addedToCart: 'කර්ට් එකට එකතු කරන ලදී!', orderInfo: '' }
};

export default medicineProductSl;


